import script from "./LoadingPopup.vue?vue&type=script&setup=true&lang=js"
export * from "./LoadingPopup.vue?vue&type=script&setup=true&lang=js"

import "./LoadingPopup.vue?vue&type=style&index=0&id=c4a36f60&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c4a36f60"]])

export default __exports__